export default function(instance) {
  return {
    getAllPasses() {
      return instance.get("/api/passes/admin/");
    },
    filterPasses(data) {
      //remove empty value
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      if (!(Object.keys(data).length === 0 && data.constructor === Object)) {
        return instance.get("/api/passes/filter/", {
          params: data
        });
      } else {
        return instance.get("/api/passes/");
      }
    },
    createPass(data) {
      return instance.post("/api/passes/admin/", data);
    },
    updatePass(id, data) {
      return instance.put(`/api/passes/admin/${id}/`, data);
    },
    updateStatusPass(data) {
      return instance.post("/api/passes/mark/", {
        passs: data.id,
        kind: data.kind
      });
    },
    getActions(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/passes/actions/admin/", {
        params: data
      });
    },
    getActionsPass(id) {
      return instance.get(`/api/passes/actions/${id}/`);
    },
    deletePass(idPass) {
      return instance.delete(`/api/passes/admin/${idPass}/`);
    },

    //Upload Images
    uploadPhotoPass(id, data) {
      let formData = new FormData();
      formData.append("photo", data.photo);

      return instance.post(`/api/passes/upload/photo/${id}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
    uploadScanPass(id, data) {
      let formData = new FormData();
      formData.append("passport_scan", data.passport_scan);

      return instance.post(`/api/passes/upload/scan/${id}/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },

    //Instructions
    getInstructions() {
      return instance.get("/api/passes/instruction/");
    },
    updateInstructions(data) {
      return instance.put("/api/passes/instruction/", {
        text: data
      });
    }
  };
}
